import React from 'react';
import Auth from './pages/auth';
import Home from './pages/home';
import {useAuth} from './providers/auth';

function App() {
  const {isLoggedIn} = useAuth();
  return (
    <>
      {isLoggedIn && <Home />}
      {!isLoggedIn && <Auth />}
    </>
  );
}

export default App;
